import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useCatalogs(env, client) {
  const [loadedCatalogs, setLoadedCatalogs] = useState(false);
  const [catalogs, setCatalogs] = useState(null);

  useEffect(() => {
    setLoadedCatalogs(false);
    if (!client) {
      setLoadedCatalogs(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "catalogs");
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCatalogs(data);
      setLoadedCatalogs(true);
    });
    return () => unsub();
  }, [env, client]);

  return {loadedCatalogs, catalogs};
}